import { Component, OnInit } from "@angular/core";
import { AddClassModifierDirective } from "src/app/core/directives/add-class-modifier.directive";
import { GroupedNavItems } from "src/models/nav";
import { AppService } from "src/services/app.service";
import { NavGroupComponent } from "../nav-group/nav-group.component";

@Component({
  selector: "app-nav-bar",
  templateUrl: "./nav-bar.component.html",
  styleUrl: "./nav-bar.component.scss",
  imports: [AddClassModifierDirective, NavGroupComponent],
})
export class NavBarComponent implements OnInit {
  isSideBarCollapsed = this.appService.isSideBarCollapsed;
  navBarGroups: GroupedNavItems[] = [];

  constructor(private appService: AppService) {}

  ngOnInit() {
    this.appService.getGroupedNavItems().subscribe((groups) => {
      this.navBarGroups = groups.filter((group) => group.items.length > 0);
    });
  }
}
